import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["isHighlighted", "children", "top"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Box, Container, Section } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultCard = {
  paddingLeft: 10,
  paddingRight: 10,
  width: ['50%', '33.33%'],
  marginTop: [28, 40]
};
var highlightedCard = {
  paddingLeft: 10,
  paddingRight: 10,
  width: ['100%', '50%'],
  marginTop: [32, 20]
};

var CardGrid = function CardGrid(_ref) {
  var isHighlighted = _ref.isHighlighted,
      children = _ref.children,
      top = _ref.top,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Section, _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs(Container, {
      children: [top && /*#__PURE__*/_jsx(Box, {
        children: top
      }), /*#__PURE__*/_jsx(Box, {
        $styles: {
          display: 'flex',
          marginLeft: -10,
          flexFlow: 'row wrap'
        },
        children: React.Children.map(children, function (child) {
          return /*#__PURE__*/_jsx(Box, {
            $styles: isHighlighted ? highlightedCard : defaultCard,
            children: child
          });
        })
      })]
    })
  }));
};

export default CardGrid;